const getConfigVariables = () => {
    switch (window.location.hostname) {
        case 'expert.suitsupply.com':
            return {
                API_URL: `https://appointment.suitsupply.com/api`,
                BOOKING_URL: 'https://appointment.suitsupply.com',
                EMPLOYEE_API_URL:
                    'https://employeeapi-prd-api-web.azurewebsites.net/api',
                GROUP_APPOINTMENT_ID: 'T1EC1Exxr1BcIaEq0njq',
                AVO_ENV: 'Prod',
                SHOPPING_SERVICE_ID: 'M7eqRWLNEAIfFAxr0jmz'
            };
        case 'acc.expert.suitsupply.com':
        case 'expert-acc-web.azurewebsites.net':
            return {
                API_URL: 'https://acc.appointment.suitsupply.com/api',
                BOOKING_URL:
                    'https://acc.appointment.suitsupply.com',
                EMPLOYEE_API_URL:
                    'https://employeeapi-tst-api-web.azurewebsites.net/api',
                GROUP_APPOINTMENT_ID: '6J0vJzMo9egISXpngExt',
                AVO_ENV: 'Dev',
                SHOPPING_SERVICE_ID: 'NxObOQmpbtw8LJNsNc7H'
            };
        case 'tst.expert.suitsupply.com':
        case 'expert-tst-web.azurewebsites.net':
            return {
                API_URL: 'https://tst.appointment.suitsupply.com/api',
                BOOKING_URL: 'https://tst.appointment.suitsupply.com',
                EMPLOYEE_API_URL:
                    'https://employeeapi-tst-api-web.azurewebsites.net/api',
                GROUP_APPOINTMENT_ID: '6J0vJzMo9egISXpngExt',
                AVO_ENV: 'Dev',
                SHOPPING_SERVICE_ID: 'NxObOQmpbtw8LJNsNc7H'
            };
        default:
            return {
                API_URL: `https://tst.appointment.suitsupply.com/api`,
                BOOKING_URL: 'http://localhost:3333',
                EMPLOYEE_API_URL:
                    'https://employeeapi-tst-api-web.azurewebsites.net/api',
                GROUP_APPOINTMENT_ID: '6J0vJzMo9egISXpngExt',
                AVO_ENV: 'Dev',
                SHOPPING_SERVICE_ID: 'NxObOQmpbtw8LJNsNc7H'
            };
    }
};
let {
    API_URL,
    BOOKING_URL,
    GROUP_APPOINTMENT_ID,
    EMPLOYEE_API_URL,
    AVO_ENV,
    SHOPPING_SERVICE_ID,
} = getConfigVariables();

// redirect links
const REDIRECT_URL = 'https://suitsupply.com';
const REDIRECT_URL_404 = 'https://suitsupply.com/404';

// share employeeName and Id for utm
const UTM_SHARE_EMPLOYEE = `?utm_source=share_style_advisor&utm_medium=style_advisor_button&utm_campaign=style_advisor_`;

export default {
    API_URL,
    BOOKING_URL,
    SHOPPING_SERVICE_ID,
    REDIRECT_URL,
    REDIRECT_URL_404,
    UTM_SHARE_EMPLOYEE,
    GROUP_APPOINTMENT_ID,
    EMPLOYEE_API_URL,
    AVO_ENV,
};
